import BaseLink, { LinkProps as BaseLinkProps } from 'antd/lib/typography/Link'

export interface LinkProps extends BaseLinkProps {}

export const Link = (props: LinkProps): JSX.Element => (
  <>
    <BaseLink {...props} />
  </>
)
